import { Col, Form, Row, } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import {  useSearchParams } from "react-router-dom";
import { useGetContractDetails } from "../../ServerSideStates";
import { useEffect, useState } from "react";
import { editContract } from "../../Services";
import GeneralIdentifyNo from "apps/Common/GeneralIdentifyNo";

const CustomerDetails = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
   const [searchParams,setSearchParams] = useSearchParams()
   const contractId = searchParams.get("contractId");
   
  const contractDetails = useGetContractDetails(contractId||"")
  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("key", "customerDetails");
      return newParams;
    });
  }, []);

  useEffect(()=>{
    if(contractDetails?.data?.data)
    {
      form.setFieldsValue({
        ...contractDetails?.data?.data
      })
    }
  },[contractDetails.data])

  console.log("contractDetails.data",contractDetails.data)
  
  const handleOnFinish = async() => {
      mazakaForm.setLoading()
      let formValues = form.getFieldsValue()
      let contractData = contractDetails?.data?.data
  
      try {
        const response:any = await editContract({...contractData,...formValues})
        setSearchParams((prev) => {
          const newParams = new URLSearchParams(prev);
          newParams.set("contractId", response?.data?.id);
          return newParams;
        });
        mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
        props.setSelectedKey("advisorInfoes")
       
       
      } catch (error:any) {
        mazakaForm.setFailed(2000,error?.message)
      }
  
    };


  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="">
          <MazakaInput
              xs={24}
              name={"ownerName"}
              label={"Mülk Sahibi Adı Soyadı"}
              className="!m-0"
              placeholder={"Mülk Sahibi Adı Soyadı"}
              rules={[{required:true,message:""}]}
            />
            <GeneralIdentifyNo
              xs={24}
              name={"ownerTCNo"}
              label={"Mülk Sahibi T.C. Kimlik Numarası"}
              className="!m-0"
              rules={[{required:true,message:""}]}
              
            />

<MazakaInput
              xs={24}
              name={"tenantName"}
              label={"Kiracı Adı Soyadı"}
              className="!m-0"
              rules={[{required:true,message:""}]}
              placeholder={"Kiracı Adı Soyadı"}
            />
            <GeneralIdentifyNo
              xs={24}
              name={"tenantTCNo"}
              label={"Kiracı T.C. Kimlik Numarası"}
              className="!m-0"
              rules={[{required:true,message:""}]}
              
            />
           

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Kaydet Devam Et
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default CustomerDetails;
